import React from 'react'

function Aboutus() {
  return (
    <div className=''>Aboutus</div>
  )
}

export default Aboutus